<mat-accordion>

    <mat-expansion-panel [expanded]="openFormCadastro" (closed)="openFormCadastro = false">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Ação - Oficina: {{planejamentoOficina.descricao}}
            </mat-panel-title>
        </mat-expansion-panel-header>

        <cadastrar-acoes-planejamento-oficina #cadastrarAcoes [planejamentoOficina]="planejamentoOficina"
                         [perfilAcesso]="perfilAcesso">
        </cadastrar-acoes-planejamento-oficina>
    </mat-expansion-panel>


    <mat-expansion-panel [expanded]="!openFormCadastro" (opened)="listarAcoesPlanejamentoOficina.carregarLista()"
                         (closed)="openFormCadastro = true">
        <mat-expansion-panel-header>
            <mat-panel-title>
                Lista de Ações ( {{ planejamentoOficina.acoesPlanejamentoOficina?.length }} )
            </mat-panel-title>
        </mat-expansion-panel-header>

        <listar-acoes-planejamento-oficina #listarAcoesPlanejamentoOficina
                      [acoesPlanejamentoOficina]="planejamentoOficina.acoesPlanejamentoOficina"
                      (onAtualizarAcaoPlanejamentoOficina)="onGetAdicionar($event); cadastrarAcoes.atualizarAcaoPlanejamentoOficina($event)"
                      (onAdicionar)="onGetAdicionar($event); cadastrarAcoes.cancelar()">
        </listar-acoes-planejamento-oficina>

    </mat-expansion-panel>


</mat-accordion>
